<template>
    <v-container>
        <v-row>
            <v-col cols=12 md=6>
                <v-row>
                    <v-col cols=12>
                        <h3 class="primary--text headline font-weight-black">Instrumentenfilter</h3>
                        <p style="line-height: 2;">
                            Met het instrumentenfilter ziet u in één oogopslag welke regelingen,
                            voorzieningen en instrumenten beschikbaar zijn binnen de arbeidsmarktregio.
                        </p>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols=12>
                <Search
                    :base-query="query"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<style lang="scss" scoped>
    .container {
        max-width: 100%;
    }
</style>

<script>
import Search from '@/components/search/Search';
import InstrumentsES from '@/services/InstrumentsES';

export default {
    name: 'InstrumentsSearch',
    components: {
        Search
    },
    data() {
        return {
            query: () => InstrumentsES.getQuery({
                query: {
                    bool: {
                        filter: [
                            { "term": { "is_leerwerktraject": false } },
                        ],
                    }
                }
            }),
        }
    },
}
</script>
